var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_11686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1719 5.95312H1.82812C1.05145 5.95312 0.421875 6.5827 0.421875 7.35938V18.6094C0.421875 19.386 1.05145 20.0156 1.82812 20.0156H7.82812L12 23.5312L16.1719 20.0156H22.1719C22.9485 20.0156 23.5781 19.386 23.5781 18.6094V7.35938C23.5781 6.5827 22.9485 5.95312 22.1719 5.95312Z",
    fill: "#0095DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1719 18.6094H15.6584L12 21.6923L8.34164 18.6094H1.82812C1.05145 18.6094 0.421875 17.9798 0.421875 17.2031V18.6094C0.421875 19.386 1.05145 20.0156 1.82812 20.0156H7.82812L12 23.5312L16.1719 20.0156H22.1719C22.9485 20.0156 23.5781 19.386 23.5781 18.6094V17.2031C23.5781 17.9798 22.9485 18.6094 22.1719 18.6094Z",
    fill: "#9FDCF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0807 6.36322L11.8022 8.34538C11.935 8.7103 11.7468 9.11376 11.3819 9.2466C11.017 9.3794 10.6136 9.19124 10.4807 8.82637L9.75928 6.84421L11.0807 6.36322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76782 4.21198C8.24884 4.40087 7.98125 4.97471 8.17014 5.49368L8.44803 6.2572C8.63692 6.77618 9.21076 7.04377 9.72974 6.85488L10.0528 6.73731C10.5718 6.54842 10.8393 5.97458 10.6505 5.4556L10.3726 4.69208C10.1837 4.1731 9.60983 3.90551 9.09085 4.0944L8.76782 4.21198Z",
    fill: "#781600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6545 3.31154C10.2862 3.57184 10.1378 4.0464 10.292 4.47015L10.7315 5.67758C10.8857 6.10134 11.3045 6.36944 11.7539 6.33214L15.0142 6.06151C15.6713 6.00696 16.0967 5.34252 15.8712 4.72292L14.8429 1.89773C14.6174 1.27812 13.8644 1.04255 13.326 1.42316L10.6545 3.31154Z",
    fill: "#781600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4116 4.94945C10.9495 4.98779 10.6504 5.45498 10.809 5.89065C10.9174 6.18861 11.2119 6.37713 11.5279 6.3509L15.4015 6.02935C15.8636 5.991 16.1626 5.52382 16.0041 5.08817C15.8956 4.79021 15.6012 4.60171 15.2852 4.62793L11.4116 4.94945Z",
    fill: "#221700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96982 5.63496C8.6049 5.76778 8.41676 6.17127 8.54958 6.53618C8.6824 6.90109 9.08588 7.08923 9.45079 6.95641L10.3317 6.63577C10.6966 6.50296 10.8848 6.09948 10.752 5.73458C10.6192 5.36966 10.2157 5.18151 9.85077 5.31432L8.96982 5.63496Z",
    fill: "#221700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23438 14.25V11.0625H5.10938",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23438 12.4688H4.64062",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 15.4688H13.4062C13.0179 15.4688 12.7031 15.7836 12.7031 16.1719C12.7031 16.5602 13.0179 16.875 13.4062 16.875H13.875C14.2633 16.875 14.5781 17.1898 14.5781 17.5781C14.5781 17.9664 14.2633 18.2812 13.875 18.2812H12.5156",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2031 13.875H9.32812V10.6875",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2031 13.875H12.3281V10.6875",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7656 10.6875V13.875H20.7187L19.6406 12.2813H19.5469L18.4687 13.875H18.4219V10.6875",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2969 15.0938V17.3438C11.2969 17.8615 10.8772 18.2812 10.3594 18.2812C9.84159 18.2812 9.42188 17.8615 9.42188 17.3438V15.0938",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98438 13.875C6.46659 13.875 6.04688 13.4553 6.04688 12.9375V12C6.04688 11.4822 6.46659 11.0625 6.98438 11.0625C7.50216 11.0625 7.92188 11.4822 7.92188 12V12.9375C7.92188 13.4553 7.50216 13.875 6.98438 13.875Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0781 13.875C15.5603 13.875 15.1406 13.4553 15.1406 12.9375V12C15.1406 11.4822 15.5603 11.0625 16.0781 11.0625C16.5959 11.0625 17.0156 11.4822 17.0156 12V12.9375C17.0156 13.4553 16.5959 13.875 16.0781 13.875Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9927 6.39526L10.0308 3.75236",
    stroke: "#24B6F9",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1719 2.77759L18.4933 2.2966",
    stroke: "#0095DA",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.29 1.45227L17.194 0.375036",
    stroke: "#0095DA",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3481 4.3594L18.733 4.60358",
    stroke: "#0095DA",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2188 16.875H16.9219",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 16.875H18.3281",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 16.875H6.375",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07812 16.875H7.78125",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_11686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUs);
export default __webpack_public_path__ + "static/media/follow-us.54068aa90efc90a3877c85793ee4ccd5.svg";
export { ForwardRef as ReactComponent };